<template>
    <div class="pt-4 px-6">
        <div class="flex mt-3">
            <div class="w-full text-12 font-medium text-center pb-2.5"
                :class="[active == 'detail' ? 'border-b-2 border-a-orange-fe5000 text-a-orange-fe5000' : 'border-b border-a-gray-707070 text-a-black-484848']"
                @click="clickTab('detail')">
                {{lbl.detail.detail}}
            </div>
            <div class="w-full text-12 font-medium text-center pb-2.5"
                :class="[active == 'condition' ? 'border-b-2 border-a-orange-fe5000 text-a-orange-fe5000' : 'border-b border-a-gray-707070 text-a-black-484848']"
                @click="clickTab('condition')">
                {{lbl.detail.condition}}
            </div>
            <div class="w-full text-12 font-medium text-center pb-2.5"
                :class="[active == 'location' ? 'border-b-2 border-a-orange-fe5000 text-a-orange-fe5000' : 'border-b border-a-gray-707070 text-a-black-484848']"
                @click="clickTab('location')">
                {{lbl.detail.location}}
            </div>
        </div>
        <div class="pt-3 font-light text-12 text-a-black-484848 leading-6">
            <div v-show="active == 'detail'" v-html="detailText"></div>
            <div v-show="active == 'condition'" v-html="conditionText"></div>
            <div v-show="active == 'location'" v-html="locationText"></div>
        </div>
    </div>
</template>
<script>
import Util from "@/helper/Utility.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";

export default {
    name: "DetailAndCondition",
    mixins: [LocaleMixin],
    props: {
        campaign: { type: Object, required: true },
    },
    data: function() {
        return {
            active: 'detail', // detail, condition

            detailText: null,
            conditionText: null,
            locationText: null,
        };
    },
    created: function() {
        this.detailText = Util.newLineToBr(this.campaign.detail);
        this.conditionText = Util.newLineToBr(this.campaign.condition);
        this.locationText = Util.newLineToBr(this.campaign.location);
    },
    methods: {
        clickTab: function(active) {
            this.active = active;
        },
    }
}
</script>
